import React, { Fragment } from "react";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import { Toys, Grain, TrendingDown } from "@material-ui/icons";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CountUp from "react-countup";

import PieResourcesCO2 from "components/services/PieResourcesCO2";
import BarWasteResources from "components/services/BarWasteResources";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function ResourcesBusiness() {
  const classes = useStyles();

  return (
    <Fragment>
      <GridContainer>
        <GridItem xs={12} md={8}>
          <Card chart>
            <CardBody>
              <h4 className={classes.cardTitleGraphs}>
                <Toys className={classes.icontext} />
                Categorías de residuos registrados.
              </h4>
              <BarWasteResources />
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} md={4}>
          <Card chart>
            <CardBody>
              <h4 className={classes.cardTitleGraphs}>
                Total de recursos en KG.
              </h4>
              <div className={classes.cardTitleCountDinamic}>
                <Grain />
                <CountUp
                  // className="account-balance"
                  start={0}
                  end={parseInt(650)}
                  duration={12}
                  useEasing={true}
                  //useGrouping={true}
                  // separator=" "
                  //decimals={4}
                  //decimal=","
                  //prefix="EUR "
                  //suffix=" left"
                  /*onComplete={onComplete}
          onStart={onStart}*/
                />
                <small>kg</small>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card chart>
            <CardBody>
              <h4 className={classes.cardTitleGraphs}>
                <TrendingDown className={classes.icontext} />
                Disminución de CO2 por categoría de residuo.
              </h4>
              <PieResourcesCO2 />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
}
